import React from 'react';
import { Col } from 'react-bootstrap';

export const Spot = ({ title, image }) => (
	<Col className="image-column pull-left" md={5} sm={12} xs={12}>
		<div className="clearfix">
			<div className="out-box">
				<div className="image-box" style={{ backgroundImage: `url(${image})` }} />
				<div className="text-box">
					<div className="text" dangerouslySetInnerHTML={{ __html: `${title}` }} />
				</div>
			</div>
		</div>
	</Col>
);



// WEBPACK FOOTER //
// ./src/components/ui/Spot/Spot.js